<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <TableRoles ref="table" :showTitle="false" :companyId="companyId" :isCompanyView="true"/>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-btn @click="createItem()" color="primary" >Neu erstellen</v-btn>
    </v-col>

  </v-row>
</template>

<script>
import Vue from 'vue'
import TableRoles from "../../tables/TableRoles";

export default {
  name: 'TabPlaylist',
  components: {TableRoles},
  props: {
    companyId: String
  },
  methods: {
    open: function () {
      this.$refs.table.reload()
    },
    createItem: function () {
      console.log('createItem')
      Vue.prototype.$apiRole.createRole({
        guidParent: this.companyId
      }, this.onPlayListCreated)
    },
    onPlayListCreated: function (newItem) {
      console.log('onPlayListCreated', newItem)
      this.$router.push('/Netzwerke/' + this.companyId + '/Rollen/' + newItem.guid)
    }
  },
  data () {
    return {}
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
